var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"id":"trainings","fluid":"","tag":"section"}},[_c('span',{staticClass:"background"})])
}
var staticRenderFns = []

export { render, staticRenderFns }